// import { createContext, useState, useEffect, useCallback } from "react";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// // adjust path based on your structure

// export const AuthContext = createContext();

// const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   // 🔹 Logout function (with backend call)
//   const logout = useCallback(async () => {
//     try {
//       const token = localStorage.getItem("token");
//       if (token) {
//         await axios.post(
//           `${API_URL}/api/auth/logout`,
//           {}, // body (if backend expects nothing)
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//       }
//     } catch (error) {
//       console.error("Logout API error:", error.response?.data || error.message);
//     } finally {
//       // Always clear local storage and reset state
//       localStorage.removeItem("token");
//       setUser(null);
//       setIsAuthenticated(false);
//     }
//   }, []);

//   // 🔹 Decode + validate token
//   const decodeAndValidateToken = useCallback(
//     (token) => {
//       try {
//         const decoded = jwtDecode(token);

//         // Check token expiry
//         if (decoded.exp * 1000 < Date.now()) {
//           logout();
//           return null;
//         }

//         return {
//           id: decoded.userId,
//           name: `${decoded.firstName} ${decoded.lastName}`,
//           email: decoded.email,
//           accountType: decoded.accountType,
//           accountStatus: decoded.accountStatus,
//         };
//       } catch (error) {
//         console.error("Token validation failed:", error);
//         logout();
//         return null;
//       }
//     },
//     [logout]
//   );

//   // 🔹 Login function
//   const login = useCallback(
//     (token) => {
//       localStorage.setItem("token", token);
//       const decoded = decodeAndValidateToken(token);
//       if (decoded) {
//         setUser(decoded);
//         setIsAuthenticated(true);
//       }
//     },
//     [decodeAndValidateToken]
//   );

//   // 🔹 On mount, check existing token
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const userData = decodeAndValidateToken(token);
//       if (userData) {
//         setUser(userData);
//         setIsAuthenticated(true);
//       }
//     }
//     setLoading(false);
//   }, [decodeAndValidateToken]);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         isAuthenticated,
//         loading,
//         login,
//         logout,
//       }}
//     >
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthProvider;



import { createContext, useState, useEffect, useCallback } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { API_URL } from "../../Constants";
// adjust path based on your structure

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // 🔹 Logout function (with backend call)
  const logout = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        await axios.post(
          `${API_URL}/api/auth/logout`,
          {}, // body (if backend expects nothing)
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
    } catch (error) {
      console.error("Logout API error:", error.response?.data || error.message);
    } finally {
      // Always clear local storage and reset state
      localStorage.removeItem("token");
      setUser(null);
      setIsAuthenticated(false);
    }
  }, []);

  // 🔹 Decode + validate token
  const decodeAndValidateToken = useCallback(
    (token) => {
      try {
        const decoded = jwtDecode(token);

        // Check token expiry
        if (decoded.exp * 1000 < Date.now()) {
          logout();
          return null;
        }

        // 🔹 Mapped to match your specific JWT payload
        return {
          id: decoded.userId,
          email: decoded.sub,
          role: decoded.role, 
          // Extracting the part before '@' as a display name fallback
          name: decoded.sub ? decoded.sub.split('@')[0] : "User", 
        };
      } catch (error) {
        console.error("Token validation failed:", error);
        logout();
        return null;
      }
    },
    [logout]
  );

  // 🔹 Login function
  const login = useCallback(
    (token) => {
      localStorage.setItem("token", token);
      const decoded = decodeAndValidateToken(token);
      if (decoded) {
        setUser(decoded);
        setIsAuthenticated(true);
      }
    },
    [decodeAndValidateToken]
  );

  // 🔹 On mount, check existing token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const userData = decodeAndValidateToken(token);
      if (userData) {
        setUser(userData);
        setIsAuthenticated(true);
      }
    }
    setLoading(false);
  }, [decodeAndValidateToken]);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        loading,
        login,
        logout,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;